module.exports = __webpack_public_path__ + "img/end_w2.8281cd31.png";